import { shuffleAndAvoidOriginalOrder } from "seneca-common/utils/functions/random/shuffle";

import { GenerateContentOptions } from "../../types";
import { Content, ContentSource } from "../types";

export function generateContent(
  source: ContentSource,
  { testingActive }: GenerateContentOptions
): Content {
  return {
    ...source,
    values: testingActive
      ? shuffleAndAvoidOriginalOrder(source.orderedValues)
      : source.orderedValues
  };
}
